import { Enviroment } from '../../../../../_config/constants/enviroment-v2.constant';
import CustomSteps from '../../../../../v2-components/Antd/Steps';
import { status } from './constants/status.constant';
import { handleDescription } from './handle/description.handle';

export default function TrackingProgress(props) {

	const progress = props?.data?.process;

	const filteredStatus = status[Enviroment.LANGUAGE].filter((s) => progress?.some((p) => p.status === s.status));

	const steps = filteredStatus.map((item, index) => {
		const description = progress.filter((item) => item.status === filteredStatus[index].status);
		return {
			title: item.description,
			description: handleDescription(description),
		};
	});

	const current = steps.length - 1;


	return (
		<>
			<p>
				Farmacia {props?.data?.quotation?.pharmacy[0]}
			</p>
			<h2>Tracking de pedido</h2>
			<CustomSteps progressDot size="small"  direction="vertical" current={current} items={steps} />
		</>
	);
}
